import React from "react";
import { Typography, Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

function RegisterSuccessPhD() {
  return (
    <React.Fragment>
      <CheckCircleIcon
        fontSize="large"
        color="primary"
        sx={{ fontSize: 70, margin: 3 }}
      />
      <Typography variant="h4" gutterBottom sx={{ margin: 1 }}>
        Update completed
      </Typography>
      <Button size="large" variant="contained" href="/member" sx={{ margin: 4 }}>
        OK
      </Button>
    </React.Fragment>
  );
}

export default RegisterSuccessPhD;
